/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-score';
const componentName = 'avi-health-score-body';
const prefix = `${moduleName}.${componentName}`;

export const trendingScoreLabel = `${prefix}.trendingScoreLabel`;
export const enabledLabel = `${prefix}.enabledLabel`;
export const deactivatedLabel = `${prefix}.deactivatedLabel`;
export const appSecurityLabel = `${prefix}.appSecurityLabel`;
export const appSecurityInfoEnableLabel = `${prefix}.appSecurityInfoEnableLabel`;
export const appSecurityInfoDeactivatedLabel = `${prefix}.appSecurityInfoDeactivatedLabel`;

export const ENGLISH = {
    [trendingScoreLabel]: 'Trending Score',
    [enabledLabel]: 'Enabled',
    [deactivatedLabel]: 'Deactivated',
    [appSecurityLabel]: 'WAF',
    [appSecurityInfoEnableLabel]: 'This Virtual Service is protected by the Avi WAF. Refer to the security dashboard for more details.',
    [appSecurityInfoDeactivatedLabel]: 'This Virtual Service is NOT protected by Avi WAF.',
};
